<template>
  <div class="container-fluid">
    <Nav></Nav>
    <section id="hero">
      <div class="main">
        <div class="some-space"></div>
        <div class="row">
          <div class="col">
            <img :src="require('@/assets/imgLandingPhone.png')" alt>
          </div>
          <div class="col mobile-bg pt-4">
            <img :src="require('@/assets/icWwwLogo.png')" alt>
            <div class="r-lead-1">what wear & when</div>
            <div class="r-lead-2">
              Contain your calendar and closet
              in a digital space.
            </div>
            <div class="r-lead-3">
              Showing up to your events is your priority.
              Helping you remember what you wore is ours.
            </div>
            <div class="pb-4">
              <a class="app-store-btn" :href="'https://itunes.apple.com/us/app/what-wear-when/id1187077646?mt=8'">
                <img :src="require('@/assets/imgAppStore.png')" alt>
              </a>
              <script type="application/javascript"> 
                pintrk('track', 'Donwload button');
              </script>
              <noscript>
                <img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?event=init&tid=2612498635849&pd[em]=<hashed_email_address>&noscript=1" />
              </noscript>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="arrow">
              <img :src="require('@/assets/downArrow.png')" alt>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="features">
      <div class="main-2 d-flex flex-column">
        <div class="some-space"></div>
        <div class="row">
          <div class="col-lg-8 align-middle">
            <div class="l-lead-1 py-4">snap photos. create outfits.</div>
            <div class="py-3">
              <img :src="require('@/assets/icArticles.png')" alt>
            </div>
            <div class="l-lead-2 py-4">What do you love in your closet? Take a photo!</div>
            <div class="py-4">
              <img :src="require('@/assets/icOutfit.png')" alt>
            </div>
            <div
              class="l-lead-3 py-4"
            >We’ll help you maximize your wardrobe. Just mix and match to create new outfits.</div>
          </div>
          <div class="col-lg-4">
            <img :src="require('@/assets/imgFeatures.png')" alt>
          </div>
        </div>
      </div>
    </section>
    <section id="ig">
      <div class="main-3">
        <div class="some-space"></div>
        <div class="row mobile-ig-bg">
          <div class="p-3"></div>
          <div class="col mx-auto ig-cont">
            <div class="p-3">
              <img :src="require('@/assets/instagram.png')" alt>
            </div>
            <div class="p-1"></div>
            <div class="ig-cont-lead-1">Follow us on Instagram</div>
            <div class="p-1"></div>
            <div class="ig-cont-lead-2">
              <a :href="'https://www.instagram.com/whatwearwhenapp/'">@whatwearwhenapp</a>
            </div>
            <div class="p-3"></div>
            <div class="ig-cont-lead-3">We'll be posting daily inspiration and fashion tips.</div>
            <div class="p-3"></div>
          </div>
        </div>
      </div>
    </section>
    <section id="subscribe">
      <div class="main-4 d-flex justify-content-center">
        <div class="some-space"></div>
        <div class="row">
          <div class="col">
            <div class="p-3"></div>
            <div class="p-4">
              <img :src="require('@/assets/icWwwLogo.png')" alt>
            </div>
            <div class="m4-lead-1 p-1">what wear & when</div>
            <div class="p-2">
              <a :href="'https://itunes.apple.com/us/app/what-wear-when/id1187077646?mt=8'">
                <img :src="require('@/assets/imgAppStore.png')" alt>
              </a>
              <script type="application/javascript"> 
                pintrk('track', 'Donwload button');
              </script>
              <noscript>
                <img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?event=init&tid=2612498635849&pd[em]=<hashed_email_address>&noscript=1" />
              </noscript>
            </div>
            <div class="p-3"></div>
            <div class="divider-line"></div>
            <!-- <div
              class="m4-lead-2 p-2"
            >Sign up with your email to receive the latest news and updates.</div> -->
            <div class="row">
            <!-- Begin Mailchimp Signup Form -->
              <div id="mc_embed_signup" class="col">
                <form action="https://whatwearandwhen.us14.list-manage.com/subscribe/post?u=39eaa57b162cb008e57056384&amp;id=aeace5ceb7" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                    <div id="mc_embed_signup_scroll">
                    <label for="mce-EMAIL" class="m4-lead-3">Subscribe to our mailing list</label>
                    <input type="email" value="" name="EMAIL" class="email col py-2 my-2" id="mce-EMAIL" placeholder="email address" required>
                    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_39eaa57b162cb008e57056384_aeace5ceb7" tabindex="-1" value=""></div>
                    <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button btn btn-secondary"></div>
                    </div>
                </form>
              </div>
            <!--End mc_embed_signup-->
            </div>
            <div class="divider-line"></div>
            <div class="m4-lead-3 p-2">Share this page</div>
            <div class="m4-lead-4">
              <div class="d-flex justify-content-center">
                <a
                  :href="'https://www.facebook.com/What-Wear-When-355263411516318/'"
                  class="social-icon"
                >
                  <img :src="require('@/assets/facebook.png')" alt>
                </a>
                <a :href="'https://twitter.com/whatwearandwhen'" class="social-icon">
                  <img :src="require('@/assets/twitter.png')" alt>
                </a>
              </div>
            </div>
            <div class="p-3"></div>
            <a :href="'#hero'" class="to-top">
              <img :src="require('@/assets/backToTopArrow.png')" alt>
            </a>
            <div class="p-3"></div>
          </div>
        </div>
      </div>
    </section>
    <Foot></Foot>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import Foot from "@/components/Foot";
export default {
  name: "Landing",
  components: {
    Nav,
    Foot
  },
  data() {
    return {
      backgroundImage: "",
      facebookLink: "www.medlmobile.com"
    };
  },
  mounted() {
    this.$gtm.trackView('Home', '/');
    fbq('track', 'PageView');
  }
};
</script>

<style scoped>
@font-face {
  font-family: AuxinMedium;
  src: url("../fonts/AuxinMedium.ttf");
}
.container-fluid {
  padding-left: 0rem;
  padding-right: 0rem;
  overflow: hidden;
}
.main {
  min-height: 660px;
  background: url("../assets/imgLandingBg.png") no-repeat;
  background-size: cover;
}
.some-space {
  padding-bottom: 76px;
}
.app-store-btn:hover{
  border: 1px solid orange;
}
.r-lead-1 {
  /* what wear & when: */
  font-size: 40pt;
  font-family: AuxinMedium, serif;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 32px;
}
.r-lead-2 {
  font-size: 25pt;
  font-family: Athelas-Italic, serif;
  line-height: 32px;
  color: rgb(123, 207, 216);
  margin: auto auto 36px;
  max-width: 420px;
}
.r-lead-3 {
  font-size: 14pt;
  color: #fff;
  margin: auto auto 18px;
  max-width: 420px;
}
.main-2 {
  min-height: 789px;
}
.l-lead-1 {
  /* snap photos. create: */
  font-family: AuxinMedium, serif;
  font-size: 40px;
  color: #3e3e3e;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 16px;
}
.l-lead-2 {
  /* What do you love in: */
  font-family: Athelas-Italic;
  font-size: 25px;
  color: #8a8a8a;
  letter-spacing: -0.48px;
  text-align: center;
  max-width: 486px;
  margin: auto;
}
.l-lead-3 {
  /* We’ll help you maxim: */
  font-family: Athelas-Italic;
  font-size: 25px;
  color: #8a8a8a;
  letter-spacing: -0.48px;
  text-align: center;
  max-width: 486px;
  margin: auto;
}
.main-3 {
  min-height: 720px;
  background: url("../assets/imgInstagramBg.jpg") no-repeat center;
  background-size: cover;
}
.ig-cont {
  background: white;
  border-radius: 60px;
  max-width: 406px;
  margin-bottom: 30px;
  max-height: 406px;
  height: 406px;
  padding-top: 65px;
}
.ig-cont-lead-1 {
  /* Follow us on Instagr: */
  font-family: Athelas-Italic;
  font-size: 25px;
  color: #8a8a8a;
}
.ig-cont-lead-2 {
  /* @whatwearwhenapp: */
  font-family: AuxinMedium, serif;
  font-size: 25px;
  color: #29c4d5;
}
.ig-cont-lead-3 {
  /* We’ll be posting dai: */
  font-family: Geneva;
  font-size: 14px;
  color: #8a8a8a;
  letter-spacing: -0.22px;
  text-align: center;
  max-width: 250px;
  margin: -20px auto auto;
}
.main-4 {
  min-height: 789px;
}
.m4-lead-1 {
  /* imgWwwBlack: */
  font-family: AuxinMedium, serif;
  font-size: 32pt;
  color: #3e3e3e;
  margin-bottom: 16px;
}
.m4-lead-2 {
  /* Sign up with your em: */
  font-family: Athelas-Italic;
  font-size: 18px;
  color: #3e3e3e;
  letter-spacing: -0.29px;
  text-align: center;
}
.m4-lead-2-input {
  /* Rectangle 10: */
  background: #ffffff;
  border: 1px solid #e9e9e9;
  height: 54px;
  /* Email Address: */
  font-family: Geneva;
  font-size: 16px;
  color: #8a8a8a;
  letter-spacing: 0;
  text-align: center;
}
.m4-lead-2-btn {
  /* Sign up Button: */
  background: #29c4d5;
  height: 54px;
  width: 148px;
  padding: 16px;
}
.m4-lead-2-btn-copy {
  /* SIGN UP: */
  font-family: Geneva;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
}
.m4-lead-3 {
  /* Share this page: */
  font-family: Athelas-Italic;
  font-size: 18px;
  color: #8a8a8a;
  letter-spacing: -0.29px;
  text-align: center;
}
.social-icon {
  padding: 6px;
}
.divider-line {
  background-color: #e9e9e9;
  height: 1px;
  max-width: 446px;
  margin-top: 24px;
  margin-bottom: 18px;
}

.mobile-bg {
}

.mobile-ig-bg {
}

.arrow {
}
#mc_embed_signup{
  background:#fff; 
  clear:left; 
  font-size:14px;
}
@media only screen and (max-width: 477px) {
  .mobile-bg {
    height: 50%;
    background-color: rgb(62, 62, 62);
  }

  .main-3 {
    background-position: right;
  }
  .ig-cont {
    padding-top: 0;
    height: auto;
  }
  .mobile-ig-bg {
    width: auto;
    padding-left: 21.3%;
    padding-right: 21.3%;
  }

  .ig-cont-lead-2 {
    font-size: 17px;
  }

  .arrow {
    display: none;
  }
}
</style>
